import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import tzlookup from 'tz-lookup';
import moment from 'moment-timezone';
import PropTypes, { any } from 'prop-types';
import config from '../../../../../config';

import { required } from '../../../../utils/form-validation';
import {
    Location,
    Input,
} from '../../../Form';
import Popup from '../../../Popup';
import { DefaultTimeZone } from '../../../../utils/eventConstants';
import { updateDivisionSpecificDatesAfterTimeZoneUpdate, updateEventScheduleDatesAfterTimeZoneUpdate } from '../utils';

function EventLocation(props) {
    const {
        field,
        formApi,
        isEditing,
        isRegionLocked,
        isHighSchoolClub,
        isTemplate,
    } = props;

    const [location, setLocation] = useState(null);
    const [geocodeResults, setGeocodeResults] = useState(null);
    const [showRegionLockPopup, setShowRegionLockPopup] = useState(false);
    const coreUI = useSelector(({ coreUI }) => coreUI);

    const handleLocationChange = (loc) => {
        setLocation(loc);
        setGeocodeResults(null);
    };
    const handleLocationSelect = (loc) => {
        if (isEditing && isRegionLocked && (loc !== location)) {
            setShowRegionLockPopup(true);
        }
        setLocation(loc);

        geocodeByAddress(loc)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                setGeocodeResults({ lat, lng });
                if (!isHighSchoolClub && !isTemplate) {
                    const getLocationZoneName = lat && lng ? tzlookup(lat, lng) : null;
                    const getLoctaionOffset = getLocationZoneName ? moment.tz(getLocationZoneName).format('Z') : null;
                    const matchedTz = getLoctaionOffset ? coreUI.types.timeZones.find(tz => { return tz.offset === getLoctaionOffset && tz.value === getLocationZoneName; }) : null;
                    const currentTimeZone = matchedTz ? matchedTz.id : DefaultTimeZone;
                    updateEventScheduleDatesAfterTimeZoneUpdate(formApi, coreUI?.types?.timeZones, currentTimeZone);
                    updateDivisionSpecificDatesAfterTimeZoneUpdate(formApi, coreUI?.types?.timeZones, currentTimeZone);
                    if (formApi.values.eventSchedule) {
                        formApi.setValue('eventSchedule.timeZone', currentTimeZone);
                    }
                }
            })
            .catch(error => {
                console.log('Geocode Error', error);
                setGeocodeResults(null); // TODO: handle error properly
            });
    };

    const locationInputProps = {
        placeholder: 'Location (zip or city)',
        name: 'location',
    };

    return (
        <div className="col-12">
            {showRegionLockPopup && (
                <Popup
                    className="popup-sm"
                    onCloseClick={() => {
                        setShowRegionLockPopup(false);
                    }}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        gradient: true,
                        scrollable: false,
                    }}
                >
                    <div className="popup-section p24 mb32 text-dark">
                        <p>
                            The event region has been set by UTR Sports. Please contact <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} target="_blank" rel="noopener noreferrer">support</a> to update and confirm the region is set properly
                        </p>
                    </div>
                </Popup>
            )}
            <Location
                label="Where's the event located?"
                id="location"
                field={[field, 0, 'location']}
                inputProps={locationInputProps}
                handleChange={handleLocationChange}
                handleSelect={handleLocationSelect}
                useDynamicOption={true}
                showMap={true}
                geocodeResults={geocodeResults}
                description="Enter name or address of the event location."
                hoverText="If the event will be played at multiple locations, type the main facility here. You will be able to add additional sites on draws and matches for players to see."
                placeholder="Enter name or address of location"
                validate={required}
            />
            <Input field={['eventLocations', 0, 'eventLocationType']} type="hidden" />
        </div>
    );
}

EventLocation.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    isEditing: PropTypes.bool,
    isRegionLocked: PropTypes.bool,
    isHighSchoolClub: PropTypes.bool,
    isTemplate: PropTypes.bool,
};

EventLocation.defaultProps = {
    isRegionLocked: false,
    isEditing: false,
    isHighSchoolClub: false,
    isTemplate: false,
};

export default EventLocation;
